module.exports = __webpack_public_path__ + "static/media/mint.785b9ea5.mp3";